@use '@/styles/tokens' as *;

// Title: Funnel Display 24 Regular, text/primary (Figma 30:412308).
.title {
  margin: 0;
  font-size: $font-size-2xl;
  font-weight: $font-weight-regular;
  padding: 0 var(--space-6);
}

.body {
  padding: 0 0 0 var(--space-6);
}
